window.submitContactForm = function(formData, callback) {
  //console.log(formData);
  $.ajax({
    url: "https://jsonplaceholder.typicode.com/posts",
    type: "POST",
    dataType: "JSON",
    headers: {
      "Content-type": "application/json; charset=UTF-8"
    },
    data: JSON.stringify({}),
    success: function(data) {
      //console.log(data);
      callback(true);
    },
    error: function(err) {
      //console.log("hata", err);
      callback(false);
    }
  });
};

window.submitNewsletterForm = function(email, callback) {
  //console.log(email);
  $.ajax({
    url: "https://jsonplaceholder.typicode.com/posts",
    type: "POST",
    dataType: "JSON",
    headers: {
      "Content-type": "application/json; charset=UTF-8"
    },
    data: JSON.stringify({}),
    success: function(data) {
      //console.log(data);
      callback(true);
    },
    error: function(err) {
      //console.log("hata", err);
      callback(false);
    }
  });
};